import React, { Fragment, useEffect, useState } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { history } from '../../redux'
import PropTypes from 'prop-types'
import MediaQuery from 'react-responsive'
import NavTabHeader from './NavTabHeader'
import IuppHeaderMenuMobileDisconnected from './IuppHeaderMenuMobileDisconnected'
import { getButton } from 'Shared/GTM/getButton'
import { Icon } from 'loyal-react'
import AlertMessage from './AlertMessage'
import yn from 'yn'

const defaultState = {
  isMessageOpened: process.env.REACT_APP_HAS_ALERT_MESSAGE
}

const IuppHeaderDisconnected = ({ meuBairro }) => {
  const [ownState, setOwnState] = useState(defaultState)

  const HeaderLogo = () => {
    const atttributes = {
      href: '#',
      className: meuBairro
        ? 'd-block d-lg-flex mx-auto mx-md-2 logo-header-community'
        : 'd-block d-lg-flex mx-auto mx-md-2 logo-header logo-header-img logo-header-link',
      'aria-label': meuBairro ? 'Logo Comunidade iupp itaú' : 'Logo iupp itaú'
    }

    if (history.location.pathname === '/') {
      atttributes.onClick = returnHome
    }
    return (
      <a {...atttributes}>
        {meuBairro ? (
          <Fragment>
            comunidade <br />
            iupp
          </Fragment>
        ) : null}
      </a>
    )
  }

  const PersonalMenu = () => {
    return history.location.pathname === '/' ? (
      <Fragment>
        <AnchorLink
          role='menuitem'
          href='#experiences'
          data-target='#experiences'
          className='flex-item mn-item mn-experiences'
          onClick={() => {
            focusOutOnClick('#experiences')
            getButton(false, 'home', 'clique:menu', 'experiencias')
          }}
        >
          Experiências
        </AnchorLink>
        <AnchorLink
          role='menuitem'
          href='#accumulatePoints'
          data-target='#accumulatePoints'
          className='flex-item mn-item mn-accumulate-points'
          onClick={() => {
            focusOutOnClick('#accumulatePoints')
            getButton(false, 'home', 'clique:menu', 'junte-pontos')
          }}
        >
          Junte pontos
        </AnchorLink>
        <AnchorLink
          role='menuitem'
          href='#usePoint'
          data-target='#usePoint'
          className='flex-item mn-item mn-use-points'
          onClick={() => {
            focusOutOnClick('#usePoint')
            getButton(false, 'home', 'clique:menu', 'use-pontos')
          }}
        >
          Use pontos
        </AnchorLink>
        <AnchorLink
          role='menuitem'
          href='#benefits'
          data-target='#benefits'
          className='flex-item mn-item mn-benefits'
          onClick={() => {
            focusOutOnClick('#benefits')
            getButton(false, 'home', 'clique:menu', 'descontos')
          }}
        >
          Descontos
        </AnchorLink>
      </Fragment>
    ) : (
      <Fragment>
        <a
          href='#experiences'
          className='flex-item mn-item mn-experiences'
          onClick={() => {
            returnHome()
            focusOutOnClick('#experiences')
            getButton(false, 'home', 'clique:menu', 'experiencias')
          }}
        >
          Experiências
        </a>
        <a
          href='#accumulatePoints'
          className='flex-item mn-item mn-accumulate-points'
          onClick={() => {
            returnHome()
            focusOutOnClick('#accumulatePoints')
            getButton(false, 'home', 'clique:menu', 'junte-pontos')
          }}
        >
          Junte pontos
        </a>
        <a
          href='#usePoint'
          className='flex-item mn-item mn-use-points'
          onClick={() => {
            returnHome()
            focusOutOnClick('#usePoint')
            getButton(false, 'home', 'clique:menu', 'use-pontos')
          }}
        >
          Use pontos
        </a>
        <a
          href='#benefits'
          className='flex-item mn-item mn-benefits'
          onClick={() => {
            returnHome()
            focusOutOnClick('#benefits')
            getButton(false, 'home', 'clique:menu', 'descontos')
          }}
        >
          Descontos
        </a>
      </Fragment>
    )
  }

  const BusinessMenu = () => {
    return history.location.pathname === '/meu-negocio' ? (
      <Fragment>
        <AnchorLink
          role='menuitem'
          href='#benefits'
          data-target='#benefits'
          className='flex-item mn-item mn-benefits'
          onClick={() => {
            focusOutOnClick('#benefits')
            getButton(false, 'home', 'clique:menu', 'benefícios')
          }}
        >
          Benefícios
        </AnchorLink>
        <AnchorLink
          role='menuitem'
          href='#help'
          data-target='#help'
          className='flex-item mn-item mn-help'
          onClick={() => {
            focusOutOnClick('#help')
            getButton(false, 'home', 'clique:menu', 'dúvidas frequentes')
          }}
        >
          Dúvidas frequentes
        </AnchorLink>
      </Fragment>
    ) : (
      <Fragment>
        <a
          href='#benefits'
          className='flex-item mn-item mn-experiences'
          onClick={() => {
            returnHome()
            focusOutOnClick('#benefits')
            getButton(false, 'home', 'clique:menu', 'benefícios')
          }}
        >
          Benefícios
        </a>
        <a
          href='#help'
          className='flex-item mn-item mn-accumulate-points'
          onClick={() => {
            returnHome()
            focusOutOnClick('#help')
            getButton(false, 'home', 'clique:menu', 'dúvidas frequentes')
          }}
        >
          Dúvidas frequentes
        </a>
      </Fragment>
    )
  }

  const redirectLoginPage = () => {
    if (meuBairro) {
      window.location.href = process.env.REACT_APP_COMUNIDADE_IUPP_LOGIN
    } else {
      window.location.href = '/auth/login'
    }
  }

  const returnHome = () => {
    if (meuBairro) history.push('/meu-negocio')
    else history.push('/')
  }

  const focusOutOnClick = section => {
    document.activeElement.blur()

    setTimeout(() => {
      document
        .querySelector(`${section} h2`)
        .setAttribute('tabindex', '0')
      document.querySelector(`${section} h2`).focus()
      document
        .querySelector(`${section} h2`)
        .addEventListener('blur', function () {
          document
            .querySelector(`${section} h2`)
            .removeAttribute('tabindex')
        })
    }, 800)
  }

  const closeAlertMessage = () => {
    setOwnState({
      isMessageOpened: false
    })
  }

  useEffect(() => {
    if (meuBairro) {
      document.querySelector('.logo-header-community').focus()
    } else {
      document.querySelector('.logo-header').focus()
    }
  })

  return (
    <Fragment>
      <header
        id='header-disconnected'
        className='iupp-header header-disconnected'
      >
        {yn(process.env.REACT_APP_HAS_ALERT_MESSAGE) && (
          <AlertMessage
            isMessageOpened={ownState.isMessageOpened}
            messageText='Estamos passando por manutenção. Mas fique tranquilo, tudo voltará ao normal em breve. :)'
            closeAlertMessage={closeAlertMessage}
          />
        )}
        <NavTabHeader
          isBusinessActive={meuBairro}
          focusOutOnClick={() => focusOutOnClick()}
          isMessageOpened={ownState.isMessageOpened}
        />
        <nav
          id='header'
          aria-label='principal'
          className={`menu menu-navigation ${yn(ownState.isMessageOpened) && 'mt-3'}`}
        >
          <MediaQuery maxWidth={767}>
            <IuppHeaderMenuMobileDisconnected meuBairro={meuBairro} />
          </MediaQuery>
          <div className='container'>
            <HeaderLogo />
            <MediaQuery minWidth={768}>
              <div className='flexible-items-container' role='menu'>
                {meuBairro ? <BusinessMenu /> : <PersonalMenu />}
                <MediaQuery minWidth={1025}>
                  <a
                    href='#'
                    onClick={() => {
                      redirectLoginPage()
                      getButton(
                        false,
                        'home',
                        'clique:botao',
                        'Entre ou crie uma conta'
                      )
                    }}
                    className='flex-item mn-item mn-login'
                    aria-label='Entre ou crie uma conta'
                    tabIndex={0}
                  >
                    <div aria-hidden='true'>
                      Entre ou
                      <span>crie uma conta</span>
                    </div>
                  </a>
                </MediaQuery>
              </div>
            </MediaQuery>
          </div>
        </nav>
        <MediaQuery maxWidth={1024}>
          <a
            href='#'
            className='menu menu-login'
            onClick={() => {
              redirectLoginPage()
              getButton(
                false,
                'home',
                'clique:botao',
                'Entre ou crie uma conta'
              )
            }}
            aria-label='Entre ou crie uma conta'
          >
            <span className='hide-absolute enter-create-account'>Entre ou crie uma conta</span>
            <div className='flex-item mn-item mn-login d-flex' aria-hidden='true'>
              <Icon iconName='icon_profile' className='icon-sm color-ui-white mr-1' />
              Entre ou
              <span className='d-flex'>
                crie uma conta
                <Icon iconName='icon_right' className='icon-sm' />
              </span>
            </div>
          </a>
        </MediaQuery>
      </header>
    </Fragment>
  )
}

IuppHeaderDisconnected.propTypes = {
  meuBairro: PropTypes.bool
}

export default IuppHeaderDisconnected



// WEBPACK FOOTER //
// ./src/App/Header/IuppHeaderDisconnected.js